import $ from 'jquery';
import View from 'mixins/view';
import MustacheComponent from '@components/mustache-component';

export default class AbstractSponsorComment extends View {
    constructor() {
        super();

        this.template = $('#mustache-sponsor-comments');
        this.type = false;
        this.data = {};

        const html = `<article class="user-comment sponsor-comment"></article>`;
        this.setRootEl($(html));
    }

    getAttribute(attribute) {
        const data = `${attribute}-${this.type}`;
        return this.template.data(data);
    }

    exists() {
        const exists = this.getAttribute('show');
        return !!Number(exists);
    }

    render() {
        const mustache = new MustacheComponent(this.template);

        this.data.link = this.getAttribute('link');
        this.data.trackingPixel = this.getAttribute('tracking-pixel');
        this.data.type = this.type;

        mustache.set(this.data);

        const html = mustache.render();
        this.rootEl.html(html);
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/comments-views/abstract-sponsor-comment.js